import { render, staticRenderFns } from "./ThirdPartyValidation.vue?vue&type=template&id=2ccb0d89&scoped=true&"
import script from "./ThirdPartyValidation.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb0d89",
  null
  
)

export default component.exports